export default "__VITE_ASSET__ChhnLezt__"